/* eslint-disable no-shadow */
import { useEffect, useState } from 'react';
import { db } from 'codemash';
import { Config } from 'configs';
// import { getCurrentLanguage } from 'localization';
import { apiActionChooser } from 'utils/apiActionChooser';
import { resourceRequest } from 'api/client/requests';
import { useStateWithCallbackLazy } from './useStateWithCallback';

export const useFind = ({
  collectionName,
  secretKey,
  filter,
  pageSize,
  pageNumber,
  sort,
  projection,
  referencedFields,
  refresher,
  formatResult,
  noFindOnLoad,
  loadOnInit,
  filterBuilder,
  sortBuilder,
  includeCollectionNames,
  includeRoleNames,
  includeTermNames,
  includeUserNames,
  excludeCulture,
  companyIdForV2,
  resourceV2,
}) => {
  const [result, setResult] = useState([]);
  const [totalRecordsCount, setTotalRecordsCount] = useState([]);
  const [isLoading, setIsLoading] = useState(loadOnInit
    ? Config.DATA.LOADING_STATUS.INITIAL_LOAD
    : Config.DATA.LOADING_STATUS.NOT_LOADING);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [noMoreResults, setNoMoreResults] = useState(false);
  const [totalUnshifted, setTotalUnshifted] = useState(0);
  const [totalGot, setTotalGot] = useState(0);
  const [requestData, setRequestData] = useStateWithCallbackLazy({
    collectionName,
    secretKey,
    filter,
    pageSize,
    pageNumber: pageNumber || 0,
    sort,
    projection,
    referencedFields,
    refresher,
    filterBuilder,
    sortBuilder,
    includeCollectionNames,
    includeRoleNames,
    includeTermNames,
    includeUserNames,
    excludeCulture,
    companyIdForV2,
    resourceV2,
  });

  const find = async (customRequestData, refresh) => {
    // if (
    //   (refresh && isRefreshing) ||
    //   (!refresh && (noMoreResults || isLoading !== Config.DATA.LOADING_STATUS.NOT_LOADING))
    // ) {
    //   return null;
    // }

    const requestDataToUse = customRequestData || requestData;

    // console.log('--- CodeMash Find --- ');
    // console.log('1. CollectionName', requestData.collectionName);
    // console.log('2. Filter', requestData.filter);
    // console.log('3. PagingOptions', requestData.pageSize, requestData.pageNumber);
    // console.log('4. SortOptions', requestData.sort);
    // console.log('5. Projection', requestData.projection);
    // console.log('6. Referenced field', requestData.referencedFields);
    // console.log('--------------------- ');

    try {
      // if (refresh) {
      //   setIsRefreshing(true);
      // } else {
      //   setIsLoading(totalGot === 0 ? 1 : 2);
      // }

      if (isLoading !== Config.DATA.LOADING_STATUS.INITIAL_LOAD) {
        setIsLoading(Config.DATA.LOADING_STATUS.PAGING_LOAD);
      }

      let response;

      await apiActionChooser(companyIdForV2, async () => {
        response = await db.getRecords({
          secretKey: requestDataToUse.secretKey,
          database: Config.CODEMASH.DATABASE_ID,
          collectionName: requestDataToUse.collectionName,
          pageNumber: refresh ? 0 : requestDataToUse.pageNumber,
          pageSize: requestDataToUse.pageSize || Config.DEFAULTS.PAGE_SIZE,
          sort: sortBuilder ? sortBuilder() : requestDataToUse.sort,
          filter: filterBuilder ? filterBuilder() : requestDataToUse.filter,
          projection: requestDataToUse.projection,
          referencedFields: requestDataToUse.referencedFields,
          language: Config.DEFAULTS.LANGUAGE, // getCurrentLanguage(),
          excludeCulture: requestDataToUse.excludeCulture || false,
          includeCollectionNames: requestDataToUse.includeCollectionNames || false,
          includeRoleNames: requestDataToUse.includeRoleNames || false,
          includeTermNames: requestDataToUse.includeTermNames || false,
          includeUserNames: requestDataToUse.includeUserNames || false,
        });
      }, async () => {
        let builtFilter = filterBuilder ? filterBuilder() : requestDataToUse.filter;

        if (builtFilter && typeof builtFilter !== 'string') {
          builtFilter = JSON.stringify(builtFilter);
        }

        let builtProjection = requestDataToUse.projection;

        if (builtProjection && typeof builtProjection !== 'string') {
          builtProjection = JSON.stringify(builtProjection);
        }

        let builtSort = sortBuilder ? sortBuilder() : requestDataToUse.sort;

        if (builtSort && typeof builtSort !== 'string') {
          builtSort = JSON.stringify(builtSort);
        }

        response = await resourceRequest({
          data: {
            pageNumber: refresh ? 0 : requestDataToUse.pageNumber,
            pageSize: requestDataToUse.pageSize || Config.DEFAULTS.PAGE_SIZE,
            sort: builtSort,
            filter: builtFilter,
            projection: builtProjection,
            resource: requestDataToUse.resourceV2,
          },
          action: 'find',
        });
      });

      // let newTotalGot = 0;
      let formedResult = [];

      if (formatResult) {
        formedResult = formatResult(response.result);
      } else {
        formedResult = response.result || [];
      }

      setTotalRecordsCount(response?.totalCount);

      setResult([...formedResult]);

      // let currentResults;
      // if (refresh) {
      //   currentResults = [...formedResult];
      //   setResult(currentResults);

      //   newTotalGot = formedResult.length;
      //   setTotalGot(newTotalGot);

      //   if (totalUnshifted > 0) {
      //     setTotalUnshifted(0);
      //   }
      // } else {
      //   currentResults = [...result, ...formedResult];
      //   setResult(currentResults);

      //   newTotalGot = totalGot + formedResult.length;
      //   setTotalGot(newTotalGot);
      // }

      // if (newTotalGot >= response.totalCount) {
      //   setNoMoreResults(true);
      // } else {
      //   setNoMoreResults(false);
      // }
      // }

      // setNextPage(nextPage + 1);
      // setRequestData((prevData) => ({
      //   ...prevData,
      //   pageNumber: refresh ? 1 : prevData.pageNumber + 1,
      // }));
      // return currentResults;
    } catch (e) {
      setErrorMessage('tr Something went wrong');
    } finally {
      setIsLoading(Config.DATA.LOADING_STATUS.NOT_LOADING);
    }

    return null;
  };

  useEffect(() => {
    if (!noFindOnLoad) {
      find();
    }
  }, []);

  useEffect(() => {
    if (requestData.refresher !== refresher) {
      setRequestData(
        {
          collectionName,
          secretKey,
          filter,
          pageSize,
          pageNumber: pageNumber || 0,
          sort,
          projection,
          referencedFields,
          refresher,
        },
        (currentData) => {
          find(true, currentData);
        },
      );
    }
  }, [refresher]);

  return [
    find,
    result,
    isLoading,
    totalRecordsCount,
    isRefreshing,
    errorMessage,
    setIsLoading,
    // noMoreResults,
    // unshiftItem,
    // removeItem,
  ];
};
